import React from 'react'
import 'babel-polyfill'
import {
    BrowserRouter as Router,
    Route,
} from 'react-router-dom'
import PropTypes from 'prop-types'
import preflight from './admin/preflight'
import { ConnectedRouter } from 'connected-react-router'
import {
    NON_TRANSLATED_ROUTES,
    S_SPORTNECT,
} from './consts'
import LangRouter from './routes/base/LangRouter'
import ConnectedRoutes from './routes/base/ConnectedRoutes'
import CognitoCallback from './components/auth/cognito-callback'

preflight()

/**
 * Checks whether given route is translatable
 */
const isInTranslatableRoutes = () => !NON_TRANSLATED_ROUTES.includes(window.location.pathname)

/**
 * Renders base component
 * @param {Object} props
 * @returns {JSX.Element}
 * @constructor
 */
const Root = props => (
    <ConnectedRouter history={props.history}>
        <Router>
            <Route path="/cognito/oauth/callback" exact render={() => <CognitoCallback {...props} />}/>
        </Router>
        {(window.APP_CONFIG.REACT_APP_SYSTEM === S_SPORTNECT && isInTranslatableRoutes()) && (
            <LangRouter />
        )}
        {window.APP_CONFIG.REACT_APP_SYSTEM !== S_SPORTNECT && (
            <ConnectedRoutes />
        )}
    </ConnectedRouter>
)

Root.propTypes = {
    history: PropTypes.object,
}

export default Root
